import React from "react";
import Dotted from "../../assets/svgs/Dotted";
import Header from "../components/Header";
import Table from "../components/tasks/Table";

const Tasks = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />

      <div className="relative flex justify-between items-center pb-3">
        <h3 className="text-lg">Tasks</h3>
        <div className="flex items-center space-x-8 sm:space-x-16 px-5 py-1 bg-gray-50 rounded shadow-sm">
          <p className="flex flex-col items-start">
            <span className="text-2xl">17 APR</span>
            <small className="-mt-2">monday</small>
          </p>
          <button>
            <Dotted />
          </button>
        </div>
      </div>

      <div className="mb-4 flex justify-between w-full md:space-x-10">
        <div className="flex space-x-4">
          <h2 className="py-0.5 text-xs md:text-base">Status Guideline</h2>
          <h2 className="py-0.5 text-xs md:text-base border-b-4 border-red-500">
            Pending
          </h2>
          <h2 className="py-0.5 text-xs md:text-base border-b-4 border-yellow-500">
            In Progress
          </h2>
          <h2 className="py-0.5 text-xs md:text-base border-b-4 border-green-500">
            Completed
          </h2>
        </div>
        <button className="py-1.5 px-6 rounded-md pink-btn text-white ml-auto">
          Add Tasks
        </button>
      </div>

      <Table />
    </div>
  );
};

export default Tasks;
